module.exports = __webpack_public_path__ + "static/banner-texture-new-3-3e7782c0a48c9114983da8f529577913.png";